import { icons } from '../icons';
import { resolveText } from '../../i18n/resolveText';
export function renderFooter(block) {
    const footer = document.createElement('footer');
    footer.className = 'site-footer';
    const linksHtml = block.socialLinks
        .map((link) => `
      <a href="${link.href}" class="social-link" target="_blank" rel="noopener noreferrer">
        <span class="social-link__icon">${icons[link.icon]}</span>
        <span class="social-link__label">${resolveText(link.label)}</span>
        <span class="social-link__handle">${resolveText(link.handle)}</span>
      </a>`)
        .join('');
    footer.innerHTML = `
    <div class="site-footer__links">${linksHtml}</div>
    <div class="site-footer__copy">${resolveText(block.copyright)}</div>
  `;
    return footer;
}
